NtechApp.AccountPhotosUploadForm = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._form = null;
    this._$form = null;
    this._$formLightbox = null;

    this._loader = null;
    this._overlay = null;

    this._$uploader = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._$uploader = $("body").find('[data-imageuploader="accountAlbumPhoto"]');

        me._createUploader();
        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerUploadAccountPhotos]", function(e) {
            me._loadUploadedPhotosForm();
        });

        NtechApp.uploader.cancelBodyDrops();
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }
    window.test = this;
    this._construct();
    return this;
};

NtechApp.AccountPhotosUploadForm.EVENT_ALBUM_PHOTO_ADD = "NtechApp.AccountPhotosUploadForm.EventAlbumPhotoAdd";
NtechApp.AccountPhotosUploadForm.EVENT_ALBUM_PHOTO_RM = "NtechApp.AccountPhotosUploadForm.EventAlbumPhotoRm";

NtechApp.proto(NtechApp.AccountPhotosUploadForm, {
    _enableLoader: function() {
        this._overlay.on();
        this._loader.on();
    },

    _disableLoader: function() {
        this._overlay.off();
        this._loader.off();
    },

    _getLoadUploadFormRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'not_existing';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_load_account_photos_upload_form';
    },

    _getSaveUploadedPhotosRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'not_existing';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_save_account_uploaded_photos';
    },

    _getRmUploadedPhotoRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'not_existing';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_rm_account_photo';
    },

    _loadUploadedPhotosForm: function() {
        var me = this;

        me._form = new NtechApp.ModalForm();
        me._form.load(me._getLoadUploadFormRoute(), {}, function($form) {
            me._$form = $form;
            me._bindFormEvents.call(me, $form);
        });
    },

    _bindFormEvents: function($form) {
        var me = this;

        me._$uploader.find(":file").fileupload({dropZone: $form});

        me._click.listen($form.find(".formHeader .close .button"), function(event) {
            me._unloadForm();
        });

        me._click.listen($form, "[data-confirmBut]", function(e) {
            me._unloadForm();
        });

        me._click.listen($form, "[data-imageuploaderTrigger='accountAlbumPhoto']", function(event) {
            me._$uploader.find(":file").trigger("click");
        });

        me._click.listen($form.find(".uploadWrapper"), ".rmControl", function(e) {
            if(!$(e.target).hasClass("rmControl"))
                return;

            e.preventDefault();
            e.stopPropagation();

            me._rmPhoto($(e.target).closest(".gridItem"));

            return false;
        });

        var $formContent = $form.find(".formContent");
        var $scrollableFormContent = $form.find(".scrollableFormContent");

        me._loader = new NtechApp.Loader(
            35, 35, "absolute", $formContent
        );
        me._overlay = new NtechApp.Overlay(
            $form, {position: "absolute", height: "100% !important", zIndex: 2}
        );

        me._$formLightbox = new NtechApp.LightBox($form.find("[data-lightboxRoot]"), {
            disableOverlay: true,
            loaderCss: {zIndex: 1400}
        });
        $(me._$formLightbox).on(NtechApp.LightBox.EVENT_ON_OPEN, function() { 
            me._form.getOverlay().updateCss({zIndex: 1300});
        });
        $(me._$formLightbox).on(NtechApp.LightBox.EVENT_ON_CLOSE, function() {
            me._form.getOverlay().updateCss({zIndex: 1000});
        });
    },

    _unloadForm: function() {
        var me = this;
        me._form.unload();
        me._$formLightbox.destroy();
    },

    _createUploader: function() {
        var me = this;

        me._$uploader.find(":file").fileupload({
            dataType: 'json',
            formData: {
                uploadType: me._$uploader.attr("data-uploadType")
            },
            add: function(e, data) {
                $.each(data.files, function(index, file) {
                    if(!NtechApp.uploader.hasFileValidSize(file))
                        return;

                    var itemsCount = me._$form.find(".gridItem").length - 1; // 1 - Upload control
                    if(itemsCount >= 12) {
                        NtechApp.info.on("Please upload up to 12 photos.");
                        return;
                    }

                    var $item = $("<div/>").addClass("gridItem uploadedItem");
                    me._$form.find("[data-imageuploaderTrigger='accountAlbumPhoto']").after($item);

                    var itemLoader = new NtechApp.Loader(
                        35, 35, "absolute", $item
                    );
                    itemLoader.on().white();

                    data.context = {
                        $item: $item,
                        itemLoader: itemLoader
                    };
                    
                    data.submit();
                });
            },
            done: function (e, data) {
                $.each(data.result, function(i, fileData) {
                    if(fileData.error) {
                        data.context.itemLoader.off();
                        data.context.itemLoader.destroy();

                        var errText = "Error: " + fileData.errorMsg;
                        var $item = data.context.$item;
                        var $err = $("<div/>").addClass("errorText").text(errText);
                        $item.append($err);
                        me._click.listen($item, function(e) { $item.remove(); });
                    }
                    else {
                        me._finishUpload(data, fileData);
                    }
                });
            }
        });
    },

    _finishUpload: function(data, fileData) {
        var me = this;

        this._ajax.post({
            url: Routing.generate(me._getSaveUploadedPhotosRoute()),
            data: {
                image: fileData.filename
            },
            onSuccess: function(res) {
                me._insertPhoto(res, data.context.$item);
            },
            onComplete: function() {
                //me._disableLoader();
                data.context.itemLoader.off();
                data.context.itemLoader.destroy();
            }
        });
    },

    _insertPhoto: function(data, $item) {
        $item.removeClass("uploadedItem");
        $item.attr("data-modelId", data.photoId);

        var photoHtml = "";

        photoHtml += '<a href="' + data.filenameUrl + '" data-lightboxImage="e">';
        photoHtml += '    <img src="' + data.url + '" />';
        photoHtml += '    <div class="border"></div>';
        photoHtml += '    <div class="rmControl"></div>';
        photoHtml += '</a>';

        $item.append($.parseHTML(photoHtml));

        var ev = NtechApp.AccountPhotosUploadForm.EVENT_ALBUM_PHOTO_ADD;
        $(this).trigger(ev, [data.filenameUrl, data.url, data.photoId]);
    },

    _rmPhoto: function($item) {
        var me = this;
        var photoId = $item.attr("data-modelId");

        NtechApp.confirmForm.load(function() {
            me._ajax.post({
                url: Routing.generate(me._getRmUploadedPhotoRoute()),
                data: {
                    photoId: $item.attr("data-modelId")
                },
                onSuccess: function(res) {
                    $item.remove();
                    NtechApp.confirmForm.unload();

                    var ev = NtechApp.AccountPhotosUploadForm.EVENT_ALBUM_PHOTO_RM;
                    $(me).trigger(ev, [photoId]);
                },
                onComplete: function() {
                    me._disableLoader();
                }
            });
        });
    }
});